export const REPLACE_ORDER = "REPLACE_ORDER"
export const ADD_ORDER_ITEMS = "ADD_ORDER_ITEMS"
export const ADD_ORDER_ITEM = "ADD_ORDER_ITEM"
export const UPDATE_ORDER_ITEM = "UPDATE_ORDER_ITEM"
export const DELETE_ORDER_ITEM = "DELETE_ORDER_ITEM"
export const DELETE_ALL_ORDER_ITEMS = "DELETE_ALL_ORDER_ITEMS"
export const DELETE_ORDER_ITEMS_ITEM_ADD_ONS = "DELETE_ORDER_ITEMS_ITEM_ADD_ONS"
export const CLEAR_ORDER_TABLE_NUMBER = "CLEAR_ORDER_TABLE_NUMBER"
export const SET_ORDER_TABLE_NUMBER = "SET_ORDER_TABLE_NUMBER"
export const ADD_COMBO_TO_ORDER = "ADD_COMBO_TO_ORDER"
export const EDIT_COMBO_TO_ORDER = "EDIT_COMBO_TO_ORDER"
export const DELETE_COMBO_FROM_ORDER = "DELETE_COMBO_FROM_ORDER"
export const CONVERT_ORDER_ITEMS_TO_BUY_X_FREE_X = "CONVERT_ORDER_ITEMS_TO_BUY_X_FREE_X"
